import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/agent.js'), 'agent.js')
  resolveStoreModules(require('../store/ask-airene.js'), 'ask-airene.js')
  resolveStoreModules(require('../store/billable_usages.js'), 'billable_usages.js')
  resolveStoreModules(require('../store/call.js'), 'call.js')
  resolveStoreModules(require('../store/campaign.js'), 'campaign.js')
  resolveStoreModules(require('../store/chat.js'), 'chat.js')
  resolveStoreModules(require('../store/contact.js'), 'contact.js')
  resolveStoreModules(require('../store/conversation_history.js'), 'conversation_history.js')
  resolveStoreModules(require('../store/conversation.js'), 'conversation.js')
  resolveStoreModules(require('../store/customer.js'), 'customer.js')
  resolveStoreModules(require('../store/division.js'), 'division.js')
  resolveStoreModules(require('../store/fcm.js'), 'fcm.js')
  resolveStoreModules(require('../store/ig_comment.js'), 'ig_comment.js')
  resolveStoreModules(require('../store/inbox.js'), 'inbox.js')
  resolveStoreModules(require('../store/infinite.js'), 'infinite.js')
  resolveStoreModules(require('../store/layouts.js'), 'layouts.js')
  resolveStoreModules(require('../store/mqtt.js'), 'mqtt.js')
  resolveStoreModules(require('../store/organization.js'), 'organization.js')
  resolveStoreModules(require('../store/package.js'), 'package.js')
  resolveStoreModules(require('../store/preferences.js'), 'preferences.js')
  resolveStoreModules(require('../store/report.js'), 'report.js')
  resolveStoreModules(require('../store/score.js'), 'score.js')
  resolveStoreModules(require('../store/shopee.js'), 'shopee.js')
  resolveStoreModules(require('../store/shopeeInbox.js'), 'shopeeInbox.js')
  resolveStoreModules(require('../store/sidebar.js'), 'sidebar.js')
  resolveStoreModules(require('../store/subscribe_plan.js'), 'subscribe_plan.js')
  resolveStoreModules(require('../store/template.js'), 'template.js')
  resolveStoreModules(require('../store/ticket.js'), 'ticket.js')
  resolveStoreModules(require('../store/tokopedia.js'), 'tokopedia.js')
  resolveStoreModules(require('../store/triggers.js'), 'triggers.js')
  resolveStoreModules(require('../store/unified_app.js'), 'unified_app.js')
  resolveStoreModules(require('../store/users.js'), 'users.js')
  resolveStoreModules(require('../store/usman.js'), 'usman.js')
  resolveStoreModules(require('../store/channels/email.js'), 'channels/email.js')
  resolveStoreModules(require('../store/channels/facebook.js'), 'channels/facebook.js')
  resolveStoreModules(require('../store/channels/instagram.js'), 'channels/instagram.js')
  resolveStoreModules(require('../store/channels/line.js'), 'channels/line.js')
  resolveStoreModules(require('../store/channels/livechatcom.js'), 'channels/livechatcom.js')
  resolveStoreModules(require('../store/channels/mobilechat.js'), 'channels/mobilechat.js')
  resolveStoreModules(require('../store/channels/qiscus.js'), 'channels/qiscus.js')
  resolveStoreModules(require('../store/channels/qontak_crm.js'), 'channels/qontak_crm.js')
  resolveStoreModules(require('../store/channels/telegram.js'), 'channels/telegram.js')
  resolveStoreModules(require('../store/channels/twitter.js'), 'channels/twitter.js')
  resolveStoreModules(require('../store/channels/webchat.js'), 'channels/webchat.js')
  resolveStoreModules(require('../store/channels/whatsapp.js'), 'channels/whatsapp.js')
  resolveStoreModules(require('../store/chatbot_usage/basic_package.js'), 'chatbot_usage/basic_package.js')
  resolveStoreModules(require('../store/chatbot_usage/reporting.js'), 'chatbot_usage/reporting.js')
  resolveStoreModules(require('../store/contact_object/contact.js'), 'contact_object/contact.js')
  resolveStoreModules(require('../store/contact_object/custom_field.js'), 'contact_object/custom_field.js')
  resolveStoreModules(require('../store/crm/ticket.js'), 'crm/ticket.js')
  resolveStoreModules(require('../store/customer/satisfaction_survey.js'), 'customer/satisfaction_survey.js')
  resolveStoreModules(require('../store/package_usage/additional_package.js'), 'package_usage/additional_package.js')
  resolveStoreModules(require('../store/package_usage/basic_package.js'), 'package_usage/basic_package.js')
  resolveStoreModules(require('../store/package_usage/billings.js'), 'package_usage/billings.js')
  resolveStoreModules(require('../store/package_usage/reporting.js'), 'package_usage/reporting.js')
  resolveStoreModules(require('../store/package_usage/topup.js'), 'package_usage/topup.js')
  resolveStoreModules(require('../store/package_usage/usage_chart.js'), 'package_usage/usage_chart.js')
  resolveStoreModules(require('../store/reports/agent_performance.js'), 'reports/agent_performance.js')
  resolveStoreModules(require('../store/reports/billing.js'), 'reports/billing.js')
  resolveStoreModules(require('../store/reports/broadcast.js'), 'reports/broadcast.js')
  resolveStoreModules(require('../store/reports/ces.js'), 'reports/ces.js')
  resolveStoreModules(require('../store/reports/contact.js'), 'reports/contact.js')
  resolveStoreModules(require('../store/reports/csat.js'), 'reports/csat.js')
  resolveStoreModules(require('../store/reports/export_conversation.js'), 'reports/export_conversation.js')
  resolveStoreModules(require('../store/reports/general.js'), 'reports/general.js')
  resolveStoreModules(require('../store/reports/nps.js'), 'reports/nps.js')
  resolveStoreModules(require('../store/settings/token_api.js'), 'settings/token_api.js')
  resolveStoreModules(require('../store/settings/sla_management/create_policy.js'), 'settings/sla_management/create_policy.js')
  resolveStoreModules(require('../store/settings/subscriptions/order_history.js'), 'settings/subscriptions/order_history.js')
  resolveStoreModules(require('../store/settings/wa_manager/phone_number.js'), 'settings/wa_manager/phone_number.js')
  resolveStoreModules(require('../store/settings/wa_manager/server.js'), 'settings/wa_manager/server.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
